import { get } from "../../lib/fetchUtil";

export async function fetchPolicy(policyNr: string): Promise<Policy> {
  const response = await get(`policy/getdlp?policyNumber=${policyNr}`);

  return response.json();
}

export interface Policy {
  effectiveDate: string;
  policyNumber: string;
  productName: string;
  productCode: string;
  policyHolders: PolicyHolder[];
  covers: Cover[];
  premium: Premium;
  systemId: string;
  billingDetails: BillingDetails;
  costCalculations: CostCalculation[];
}

export interface Premium {
  startDate: string;
  endDate: string;
  paymentPeriod: string;
  amount: number;
}

export interface BillingDetails {
  iban: string;
}

export interface PolicyHolder {
  givenName: string;
  prefixName: string;
  surName: string;
  gender: string;
  contactId: string;
}

export interface Cover {
  effectiveDate: string;
  expiredOnDate: string;
  insuranceType: string;
  insuredAmount: number;
  insuredObjects: InsuredObject[];
  premium?: Premium;
}

export interface InsuredObject {
  insured: Insured;
}

export interface Insured {
  smoker: boolean;
  givenName: string;
  prefixName: string;
  surName: string;
  gender: string;
  dateOfBirth: string;
  contactId: string;
  effectiveDate: string;
  expiredOnDate: string;
}

export interface CostCalculation {
  amount: number;
  paymentPeriod: string;
}
